import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, from, map } from 'rxjs';
import { HttpService } from 'src/app/_services/http.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  // private HOST = 'http://ec2-13-233-111-157.ap-south-1.compute.amazonaws.com/';
  private VOYAGE_HOST = `${environment.etsVoyage}/`;
  private HOST = `${environment.etsBaseUrl}/`;

  constructor(private http: HttpClient) { }

  getData(endpoint: string, options?:any): Observable<any> {
    let httpParams = new HttpParams();

    // Append each parameter to HttpParams
    if (options) {
      Object.keys(options).forEach(key => {
        httpParams = httpParams.append(key, options[key]);
      });
    }
    options = { params: httpParams };
    return this.http.get(`${this.HOST}${endpoint}`, options)
  }

  findById(id:string, endpoint:string){
    return this.http.get(`${this.HOST}${endpoint}/${id}`)
  }

  addData(endpoint:string, body:any){
    return this.http.post(`${this.HOST}${endpoint}`, body, {responseType: 'text'})
  }

  updateById(endpoint:string, id: string,  body:any){
    return this.http.put(`${this.HOST}${endpoint}/${id}`,body)
  }

  update(endpoint:string, body:any){
    return this.http.put(`${this.HOST}${endpoint}`,body)
  }

  updateByPost(endpoint:string, body:any){
    return this.http.post(`${this.HOST}${endpoint}`,body)
  }

  getByPost(endpoint:string, body:any){
    return this.http.post(`${this.HOST}${endpoint}`,body)
  }
  
  deleteById(endpoint:string, id: string){
    return this.http.delete(`${this.HOST}${endpoint}/${id}`)
  }
  // deleteByIdParams(endpoint:string, params:any){
  //   params = {params: params}
  //   return this.http.delete(`${this.HOST}${endpoint}`, params)
  // }
  deleteByIdParams(endpoint: string, params: any) {
    return this.http.delete(`${this.HOST}${endpoint}`, { params, responseType: 'text' });
  }
  
  getRemarks(endpoint:any){
    return this.http.get(`${this.HOST}${endpoint}`).pipe(
      map(response => {
        if (Array.isArray(response)) {
          return response.reverse();
        }
        return response;
      })
    );
  }
  getInvoices(endpoint:string, body:any){
    this.http.post(`${this.HOST}${endpoint}`, body)
  }

  getEuaAccountingData(endpoint:string, accountNumber: string){
    return this.http.get(`${this.HOST}${endpoint}`, {params: {accountNumber}})
  }

  getAllEuaAccountingData(endpoint:string){
    return this.http.get(`${this.HOST}${endpoint}`)
  }

  getAccount(){
    return this.http.get('http://localhost:3000/account');
  }
  
  getUserList(url:any): Observable<any> {
    return this.http.get(`${this.VOYAGE_HOST}${url}`);
  }

  sendEmail(to: string, subject: string, content: string){
    let body  = {to, subject, content}
    return this.http.post(`${this.HOST}Email/SendEmail`, body);
  }
}
